import React from 'react';
import { GridProps } from 'typings';

export const Grid: React.FC<GridProps> = props => {
    return (
        <bds-grid
            container={props.container}
            direction={props.direction}
            lg={props.lg}
            md={props.md}
            md-offset={props.mdOffset}
            xs={props.xs}
            xxs={props.xxs}
            gap={props.gap}
            align-items={props.alignItems}
            justify-content={props.justifyContent}
            padding={props.padding ?? 'none'}
            margin={props.margin}
            flex-wrap={props.flexWrap}
            height={props.height}
        >
            {props.children}
        </bds-grid>
    );
};
